export default "/_next/static/images/product--series-legacy-7514dd17437bf9f4926ce452c1c0f370.svg";